module.exports = __webpack_public_path__ + "static/media/SuperShuttle_ios_1.80c7633b.jpg";